'use strict';
import {ferry} from '../../../services/ferry/ferry';
import {oauth} from "../../../services/oauth/oauth";

function delete_cookie( name ) {
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/';
}

export default ['$scope', '$routeParams',
    function($scope, $routeParams) {
        $scope.code = $routeParams.code;

        if (!$scope.code) {
            document.location.href = "/";
        }
        $scope.ui = {
            step: 1
        };

        $scope.verification = $routeParams.verificationCode;

        ['JSESSIONID', 'sharewave_JWT'].forEach(to_remove => delete_cookie(to_remove));

        ferry.sessionless_performset('account.get_invitation', [$scope.code]).then(function(x) {
            // returns user_id, code, activated, company, redirect, name, and primary_email
            let row = x[0];
            Object.assign($scope, row);
            if ($scope.name.trim().indexOf(' ') < 0) {
                $scope.name = "";
            }
            if ($scope.activated) {
                let location = "/login/";
                if ($scope.redirect) {
                    location += "?redirect=" + encodeURIComponent($scope.redirect);
                }
                document.location.href = location;
            }
            $scope.$apply();
        });

        $scope.gustActivate = function() {
            $scope.processing = true;
            document.cookie = 'no_login=true; expires=Thu, 01 Jan 2020 00:00:01 GMT; path=/';
            oauth.oAuthConnect('gust').then(function(auth_details) {
                return ferry.call('/zephyr/activate_user', {
                    request_token: auth_details.request_token,
                    user_id: $scope.user_id,
                    code: $scope.code
                }).then(function() {
                    delete_cookie('no_login');
                    analytics.track('Signed Up - User', {
                        userLogin: $scope.user_id,
                        companyID: $scope.company
                    });

                    $scope.redirect += ($scope.redirect.indexOf('?') == -1) ? '?' : '&';
                    $scope.redirect += "verificationCode=" + $scope.verification;
                    document.location.href = $scope.redirect;
                }).catch(function(response) {
                    delete_cookie('no_login');
                    if (response.message.indexOf('duplicate key value') > -1) {
                        $scope.ui.errorMessage = "Your Gust account is already linked to another GEM account.";
                    } else {
                        $scope.ui.errorMessage = "There was an issue linking your Gust account.";
                    }
                    $scope.$apply();
                });
            }).catch(function() {
                delete_cookie('no_login');
                $scope.ui.errorMessage = "There was an issue linking your Gust account.";
            }).then(function() {
                $scope.processing = false;
                $scope.$apply();
            });
        };

        $scope.doActivate = function() {
            $scope.processing = true;
            ferry.sessionless_perform('account.investor_activate', [$scope.user_id, $scope.name, $scope.code, $scope.password, false]).then(function() {
                analytics.track('Signed Up - User', {
                    userLogin: $scope.user_id,
                    companyID: $scope.company
                });

                $scope.redirect += ($scope.redirect.indexOf('?') == -1) ? '?' : '&';
                $scope.redirect += "verificationCode=" + $scope.verification;
                return ferry.call('/session/login', { email: $scope.primary_email, password: $scope.password, redirect: encodeURIComponent($scope.redirect) });
            }).then(function(x) {
                document.location.href = x;
            });
        };

        $scope.fieldCheck = function() {
            return !($scope.name && $scope.password && $scope.name.length > 1 && $scope.password == $scope.confirmpassword);
        };

    }
];



// WEBPACK FOOTER //
// ./_src/ui/preLoginApp/userRegistration/invited.js